import { render, staticRenderFns } from "./PolygonIcon.vue?vue&type=template&id=013405da&scoped=true&"
import script from "./PolygonIcon.vue?vue&type=script&lang=ts&"
export * from "./PolygonIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013405da",
  null
  
)

export default component.exports